<div>
  <mat-form-field>
    <mat-label>Начните вводить название университета</mat-label>
    <input matInput [formControl]="filter" autocomplete="off">
  </mat-form-field>

  <mat-dialog-content>
    <div>
      <div class="controls">
        <div class="groups">
          <div class="group-all" *ngIf="!singleMode">
            <mat-checkbox (change)="$event ? allToggle() : null"
                          [checked]="allSelected.all"
                          [indeterminate]="allSelected.some"
            ><b>Все университеты</b>
            </mat-checkbox>
          </div>

          <div *ngFor="let group of filteredGroups$ | async; trackBy: groupTrackByFn; let j=index" class="group">
            <div *ngIf="groupSelected[j].display && group.length > 0">
              <div class="group-name">
                <mat-checkbox *ngIf="!singleMode"
                              (change)="$event ? masterToggle(j) : null"
                              [checked]="groupSelected[j].all"
                              [indeterminate]="groupSelected[j].some"
                ><b>{{ group[0].country }}</b>
                </mat-checkbox>
                <b *ngIf="singleMode">{{ group[0].country }}</b>
              </div>
              <div>
                <mat-checkbox *ngFor="let row of group; trackBy: universityTrackByFn" class="university"
                              (click)="$event.stopPropagation()"
                              (change)="$event ? toggle(j, row) : null"
                              [checked]="selection.isSelected(row)"
                              [disabled]="!row['selectable']"
                ><span [matTooltip]="row['selectable'] ? '' : 'Неполные данные по выбранному университету: невозможно использовать в качестве бенчмарка'">{{ row.fullname }}</span>
                </mat-checkbox>
              </div>
            </div>
          </div>
          <div *ngIf="loading" class="center"><mat-spinner [diameter]="30"></mat-spinner></div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div>
      <button mat-raised-button
              color="primary"
              [disabled]="!isValid"
              (click)="complete()">{{ buttonLabel }}
      </button>
      <span class="var-label">
        {{ varLabel }}
      </span>
    </div>
  </mat-dialog-actions>
</div>
